import type { NonEmptyArray } from '@mntn-dev/utility-types'
import type { CertificationKey } from '../certification.models.ts'
import type { PackageSource } from '../package.models.ts'
import type { BillingMethod } from './billing-method.ts'
import {
  type CreditProgramKind,
  isCreditProgramKind,
} from './credit-program.ts'

export const PackageBillingMethods: Record<
  PackageSource,
  NonEmptyArray<BillingMethod>
> = {
  ctv: ['mntn_credits', 'invoice', 'stripe'], // todo QFMP-4053: remove invoice / stripe?
  linkedin: ['linkedin'],
  meta: ['meta'],
  quickframe: ['invoice', 'stripe'],
  tiktok: ['tiktok'],
}

export const getPackageSourceCreditProgramKinds = (
  packageSource: PackageSource
) => {
  return PackageBillingMethods[packageSource].filter(isCreditProgramKind)
}

/**
 * The programs that are required to participate in a project of a specific package source.
 */
export const PackageSourceProgramKindsMap: Record<
  PackageSource,
  CreditProgramKind[]
> = {
  ctv: ['mntn_credits'],
  linkedin: [], // Everyone can participate in LinkedIn
  meta: ['meta'],
  quickframe: [], // Everyone can participate in QuickFrame
  tiktok: ['tiktok'],
}

export const getCreditProgramKind = (packageSource: PackageSource) => {
  return PackageSourceProgramKindsMap[packageSource]
}

/**
 * The certifications that are required to participate in a project of a specific program.
 */
export const RequiredCertificationKeyProgramKindMap: Record<
  CreditProgramKind,
  CertificationKey | undefined
> = {
  linkedin: undefined, // There is no certification for LinkedIn
  meta: 'meta-certified',
  tiktok: 'tiktok-certified',
  mntn_credits: 'mntn-certified',
}
